module.exports = __webpack_public_path__ + "static/media/check-active.0e800b0c.svg";